/**
 * scanBridgeUpdate (Jun-2026, User-Wunsch) — prüft nach dem /ping der lokalen
 * Scan-Bridge, ob eine neuere Version vorliegt. Bridges ab v6 aktualisieren
 * sich selbst (/update lädt die neue Datei und startet neu); ältere Versionen
 * bekommen einen Download-Hinweis — der neue Installer ersetzt die alte
 * Version automatisch (Ablageort: AppData\Local\TwoWheels).
 */
import { toast } from "sonner";

export const BRIDGE = "http://127.0.0.1:18488";
export const EXPECTED_BRIDGE_VERSION = 8;

export async function maybeUpdateBridge(info) {
    if (!info || (info.version || 0) >= EXPECTED_BRIDGE_VERSION) return false;
    try {
        const src = `${window.location.origin}/scan-bridge.ps1`;
        const r = await fetch(`${BRIDGE}/update?src=${encodeURIComponent(src)}`, {
            signal: AbortSignal.timeout(20000), targetAddressSpace: "loopback", cache: "no-store",
        });
        if (r.ok) {
            toast.success("Scan-Bridge-Update wird installiert — die Bridge startet automatisch neu (ca. 5 Sek.).");
            return true;
        }
    } catch { /* ältere Bridge ohne /update-Endpoint */ }
    toast.info(`Update der Scan-Bridge verfügbar (installiert: v${info.version || "?"}, neu: v${EXPECTED_BRIDGE_VERSION})`, {
        duration: 20000,
        description: "Neue Version herunterladen und per Doppelklick starten — die alte Version wird dabei automatisch beendet und ersetzt.",
        action: {
            label: "Jetzt herunterladen",
            onClick: () => {
                const a = document.createElement("a");
                a.href = "/TwoWheels-ScanBridge.cmd";
                a.download = "TwoWheels-ScanBridge.cmd";
                document.body.appendChild(a);
                a.click();
                a.remove();
            },
        },
    });
    return false;
}
